import { observer } from 'mobx-react-lite'
import { type ProfileViewModel } from '@/features/iam/users/ProfileViewModel'
import { SectionEmpty } from '@/features/iam/users/components/SectionEmpty'
import { SelectionListContainer } from '@/features/iam/users/components/SelectionList/SelectionListContainer'
import { Icon } from '@/components/Icon'
import { SelectionEditorDialog } from '@/features/iam/users/components/SelectionEditorDialog'

export interface RolesContainerProps {
  vm: ProfileViewModel
}

export const RolesContainer = observer(function RolesContainer({
  vm,
}: RolesContainerProps) {
  const createList = (editing: boolean) => (
    <SelectionListContainer
      selectionVm={vm.general.roleSelection}
      editing={editing}
      icon={<Icon name="roles" />}
      getContent={(item) => ({
        title: item.name,
        description: item.description,
      })}
    />
  )
  return (
    <>
      {vm.general.roleSelection.selectedItems.length === 0 ? (
        <SectionEmpty>You don't have any specific roles.</SectionEmpty>
      ) : (
        createList(false)
      )}
      <SelectionEditorDialog
        title="Manage User Roles"
        description={
          <>
            Select the roles to assign to{' '}
            <strong>{vm.member.displayName}</strong>
          </>
        }
        showing={vm.general.roleSelection.modal.showing}
        onClose={vm.general.roleSelection.modal.close}
      >
        {createList(true)}
      </SelectionEditorDialog>
    </>
  )
})
